import { defineMessages } from '@/i18n'

/** Тексты хуков редактора (тосты). */
export const messages = defineMessages({
  ru: {
    createCourseFailed: 'Не удалось создать курс',
  },
  en: {
    createCourseFailed: 'Couldn’t create the course',
  },
})
